// Libraries
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AlertModule,
  EmailInputModule,
  LoadingSpinnerModule,
  ModalMessageModule,
  ModalModule,
  PasswordModule,
} from '@proximus/ng-common-components';
// Components
import { AlertsContainerComponent } from './components/alerts/alerts-container.component';
import { AliasDetailsComponent } from './components/aliases/alias-details.component';
import { AliasesContainerComponent } from './components/aliases/aliases-container.component';
import { ChangePasswordContainerComponent } from './components/change-password/change-password-container.component';
import { CreateAliasComponent } from './components/aliases/create-alias.component';
import { CreateMailboxButtonComponent } from './components/mailboxes/create-mailbox-button.component';
import { CreateMailboxContainerComponent } from './components/create-mailbox/create-mailbox-container.component';
import { EmailActiveContainerComponent } from './components/password-recovery-management/email-active-container.component';
import { EmailAddContainerComponent } from './components/password-recovery-management/email-add-container.component';
import { EmailErrorsComponent } from './components/password-recovery-management/email-errors.component';
import { EmailInputComponent } from './components/password-recovery-management/email-input.component';
import { EmailSubmitComponent } from './components/password-recovery-management/email-submit.component';
import { EmailPendingContainerComponent } from './components/password-recovery-management/email-pending-container.component';
import { MailboxDetailsComponent } from './components/mailboxes/mailbox-details.component';
import { MailboxesContainerComponent } from './components/mailboxes/mailboxes-container.component';
import { MailboxesListComponent } from './components/mailboxes/mailboxes-list.component';
import { MailboxIdComponent } from './components/create-mailbox/mailbox-id.component';
import { ManageMailboxContainerComponent } from './components/manage-mailbox/manage-mailbox-container.component';
import { MobileActiveContainerComponent } from './components/password-recovery-management/mobile-active-container.component';
import { MobileAddContainerComponent } from './components/password-recovery-management/mobile-add-container.component';
import { MobileAppPromoComponent } from './components/mobile-app-promo/mobile-app-promo.component';
import { MobileNumberErrorsComponent } from './components/password-recovery-management/mobile-number-errors.component';
import { MobileNumberInputComponent } from './components/password-recovery-management/mobile-number-input.component';
import { MobileNumberSubmitComponent } from './components/password-recovery-management/mobile-number-submit.component';
import { MobilePendingContainerComponent } from './components/password-recovery-management/mobile-pending-container.component';
import { NoRecoveryMethodsContainerComponent } from './components/password-recovery-management/no-recovery-methods-container.component';
import { PasswordRecoveryManagementContainerComponent } from './components/password-recovery-management/password-recovery-management-container.component';
import { PxMyMailAppComponent } from './components/mailapp/px-mymail-app.component';
import { ReadMymailContainerComponent } from './components/read-mymail/read-mymail-container.component';
import { RemoveAliasComponent } from './components/aliases/remove-alias.component';
// Services
import { MailboxesService } from './service/mailboxes.service';
import { AliasesService } from './service/aliases.service';
import { PasswordService } from './service/password.service';
// Pipes
import { ExcludeFilterPipe } from './pipes/exclude-filter.pipe';
// Validators
import { CheckAliasValidator } from './validators/check-alias.validator';
import { PasswordRecoveryManagementValidator } from './validators/password-recovery-management.validator';
// Guards
import { CreateMailboxGuard } from './guards/create-mailbox.guard';
// Config
// ngrx
import { AlertsUtilService } from './service/alerts.util.service';
import { ConfirmDeleteAliasComponent } from './components/aliases/confirm-delete-alias.component';
import { SkeletonMailboxesComponent } from './components/mailapp/skeleton/skeleton-mailboxes.component';
import { RouterModule } from '@angular/router';
import { AnalyticsModule, TranslationModule } from '@proximus/ng-common';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslationModule,
    AnalyticsModule,
    AlertModule,
    PasswordModule,
    LoadingSpinnerModule,
    ModalModule,
    ModalMessageModule,
    EmailInputModule,
    SharedModule,
  ],
  declarations: [
    PxMyMailAppComponent,
    MailboxesContainerComponent,
    MailboxDetailsComponent,
    MailboxesListComponent,
    ManageMailboxContainerComponent,
    MobileAppPromoComponent,
    AliasesContainerComponent,
    AliasDetailsComponent,
    CreateAliasComponent,
    RemoveAliasComponent,
    CreateMailboxContainerComponent,
    CreateMailboxButtonComponent,
    MailboxIdComponent,
    AlertsContainerComponent,
    PasswordRecoveryManagementContainerComponent,
    ChangePasswordContainerComponent,
    NoRecoveryMethodsContainerComponent,
    EmailAddContainerComponent,
    EmailPendingContainerComponent,
    EmailActiveContainerComponent,
    EmailInputComponent,
    EmailSubmitComponent,
    EmailErrorsComponent,
    MobileAddContainerComponent,
    MobilePendingContainerComponent,
    MobileActiveContainerComponent,
    MobileNumberInputComponent,
    MobileNumberSubmitComponent,
    MobileNumberErrorsComponent,
    ExcludeFilterPipe,
    ConfirmDeleteAliasComponent,
    ReadMymailContainerComponent,
    SkeletonMailboxesComponent,
  ],
  providers: [
    MailboxesService,
    AliasesService,
    PasswordService,
    CheckAliasValidator,
    PasswordRecoveryManagementValidator,
    CreateMailboxGuard,
    AlertsUtilService,
  ],
  exports: [PxMyMailAppComponent, ExcludeFilterPipe],
})
export class MailAppModule {}
